import { Link } from 'react-router-dom'

import AlertIcon from '@Icons/alert-triangle.svg?react'
import ArrowRightError from '@Icons/arrow-right-error.svg?react'
import ArrowRightSuccess from '@Icons/arrow-right-success.svg?react'
import ArrowRightWarning from '@Icons/arrow-right-warning.svg?react'
import CheckCircle from '@Icons/check-circle.svg?react'
import Clock from '@Icons/clock-fast-forward.svg?react'
import ErrorAlertCircle from '@Icons/error-alert-circle.svg?react'
import { useMeQuery } from '@Store/api'
import Mixpanel from '@Utils/mixpanel/Mixpanel'

export default {
  success: {
    Icon: <CheckCircle />,
    bgColor: 'bg-success-25',
    borderColor: 'border-success-300',
    textColor: 'text-success-600',
    titleColor: 'text-success-700',
    title: 'Import completed successfully.',
    Action: () => (
      <Link
        to="/products?orderBy=date_created&orderDirection=desc"
        className="flex flex-row mt-3 w-1/2 font-medium text-sm text-success-700"
      >
        Review products
        <ArrowRightSuccess className="ml-2" />
      </Link>
    ),
  },
  warning: {
    Icon: <AlertIcon />,
    bgColor: 'bg-warning-25',
    borderColor: 'border-warning-300',
    textColor: 'text-warning-600',
    titleColor: 'text-warning-700',
    title: 'Partial import',
    Action: () => (
      <Link
        to="/products?orderBy=date_created&orderDirection=desc"
        className="flex flex-row mt-3 w-1/2 font-medium text-sm text-warning-700"
      >
        Review imported products
        <ArrowRightWarning className="ml-2" />
      </Link>
    ),
  },
  error: {
    Icon: <ErrorAlertCircle />,
    bgColor: 'bg-error-25',
    borderColor: 'border-error-300',
    textColor: 'text-error-600',
    titleColor: 'text-error-700',
    title: 'Import cancelled',
    Action: () => {
      const { data: meData } = useMeQuery()

      const isShopify = meData?.register_source === 'Shopify'

      if (!isShopify) {
        return <></>
      }

      return (
        <Link
          onClick={() =>
            Mixpanel.track(`Shopify Restart Import Clicked`, {
              page: 'Batch Import',
            })
          }
          to="/data-management/products/shopify-import"
          className="flex flex-row mt-3 w-1/2 font-medium text-sm text-error-700"
        >
          Restart Import
          <ArrowRightError className="ml-2" />
        </Link>
      )
    },
  },
  info: {
    Icon: <Clock />,
    bgColor: 'bg-blue-25',
    borderColor: 'border-blue-300',
    textColor: 'text-blue-600',
    titleColor: 'text-blue-700',
    title: 'Import in progress',
    Action: () => (
      <div className="flex flex-row mt-3 w-1/2">
        <span className="mr-2 font-medium text-sm text-blue-700">
          Please wait...
        </span>
      </div>
    ),
  },
} as Record<string, any>
